<!--Main-->
<template>
  <div class="top-form">
    <div class="filter-container clearfix">
      <div class="left-tools">
        <el-popover placement="bottom-start" trigger="click">
          <div class="cols-setting">
            <ul>
              <li v-for="(item, index) in (handle && handle.filterFieldList) || []" :key="index">
                <el-checkbox
                  :key="index"
                  v-model="item.value"
                  :label="$t(item.label)"
                  class="filter-item"
                  @change="(e) => checkboxOnChange(e, item)"
                >{{ $t(item.label) }}</el-checkbox>
              </li>
            </ul>
          </div>
          <el-button slot="reference" icon="el-icon-s-tools" size="mini" />
        </el-popover>
        <el-button type="primary" size="mini" @click="_toggle">
          <span class="custom-icon">
            <svg-icon icon-class="filter" />
          </span>
        </el-button>
      </div>
      <div class="right-tools">
        <div class="pull-right">
          <template v-for="(item, index) in (handle && handle.btList) || []">
            <template v-if="item.show!=null?item.show:true">
              <el-tooltip
                v-if="item.type === 'button'"
                class="item"
                :key="index"
                :content="item.content"
                :disabled="item.tipDisabled !== false || false"
                placement="bottom-start"
              >
                <el-button
                  :key="index"
                  :class="`filter-${item.type}`"
                  v-waves
                  :plain="item.plain"
                  :type="item.btType"
                  :icon="item.icon"
                  :disabled="item.disabled"
                  @click="handleClick(item.event)"
                  size="mini"
                >{{ $t(item.label) }}</el-button>
              </el-tooltip>
              <el-tooltip
                v-else-if="item.type === 'button-mini'"
                :key="index"
                class="item"
                :content="item.content"
                :disabled="item.tipDisabled !== false || false"
                placement="bottom-start"
              >
                <el-button-group>
                  <slot name="import" />

                  <el-button
                    v-waves
                    :type="item.btType"
                    :icon="item.icon"
                    :disabled="item.disabled"
                    @click="handleClick(item.event)"
                    size="mini"
                  >{{ $t(item.label) }}</el-button>
                </el-button-group>
              </el-tooltip>
            </template>
          </template>
        </div>
      </div>
    </div>
    <div v-if="searchForm" class="search-form clearfix">
      <el-form ref="pageform" :inline="true" :model="data" size="mini" label-width="120px">
        <el-row :gutter="10" type="flex" style="flex-wrap: wrap">
          <template v-for="(item, index) in getConfigList()">
            <el-col
              v-if="item.type == 'input'"
              :key="index"
              :xs="24"
              :sm="12"
              :md="8"
              :lg="8"
              :xl="8"
            >
              <el-form-item :label="$t(item.label)" :label-width="item.labelWidth">
                <!-- 输入框 -->
                <el-input
                  style="width: 100%;"
                  v-model="data[item.value]"
                  :type="item.type"
                  :disabled="item.disabled"
                  :clearable="item.clearable === false ? item.clearable : true"
                  :placeholder="getPlaceholder(item)"
                  @focus="handleEvent(item.event)"
                />
              </el-form-item>
            </el-col>
            <el-col
              v-if="item.type == 'textarea'"
              :key="index"
              :xs="24"
              :sm="12"
              :md="8"
              :lg="8"
              :xl="8"
            >
              <el-form-item :label="$t(item.label)" :label-width="item.labelWidth">
                <!-- 多行输入框 -->
                <el-input
                  style="width: 100%;"
                  v-model="data[item.value]"
                  :type="item.type"
                  :autosize="item.autosize || { minRows: 1, maxRows: 4}"
                  :disabled="item.disabled"
                  :clearable="item.clearable === false ? item.clearable : true"
                  :placeholder="getPlaceholder(item)"
                  @focus="handleEvent(item.event)"
                />
              </el-form-item>
            </el-col>
            <el-col
              v-if="item.type == 'select'"
              :key="index"
              :xs="24"
              :sm="12"
              :md="8"
              :lg="8"
              :xl="8"
            >
              <el-form-item :label="$t(item.label)" :label-width="item.labelWidth">
                <!-- 选择框 -->
                <el-select
                  style="width: 155px;"
                  v-model="data[item.value]"
                  :label-width="item.labelWidth"
                  :disabled="item.disabled"
                  :clearable="item.clearable === false ? item.clearable : true"
                  :multiple="item.multiple === true ? item.multiple : false"
                  :filterable="item.filterable"
                  :placeholder="getPlaceholder(item)"
                  @change="handleEvent(item.event, data[item.value])"
                >
                  <el-option
                    v-for="(childItem, childIndex) in listTypeInfo[item.list]"
                    :key="childIndex"
                    :label="childItem.key || childItem.label"
                    :value="childItem.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col
              v-if="item.type == 'datepicker'"
              :key="index"
              :xs="24"
              :sm="24"
              :md="16"
              :lg="16"
              :xl="16"
            >
              <el-form-item :label="$t(item.label)" :label-width="item.labelWidth">
                <!-- 开始结束日期 -->
                <el-date-picker
                  style="width: 100%;"
                  v-model="data[item.value]"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :default-time="['00:00:00', '23:59:59']"
                  type="daterange"
                  align="right"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :picker-options="item.pickerOptions"
                />
              </el-form-item>
            </el-col>
            <el-col v-if="item.type == 'date'" :key="index" :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
              <el-form-item :label="$t(item.label)" :label-width="item.labelWidth">
                <el-date-picker
                  style="width: 100%;"
                  v-model="data[item.value]"
                  value-format="yyyy-MM-dd"
                  type="date"
                  align="right"
                  :default-value="new Date()"
                  :picker-options="item.pickerOptions"
                />
              </el-form-item>
            </el-col>
            <!-- 月份范围选择器 -->
            <el-col
              v-if="item.type == 'monthrange'"
              :key="index"
              :xs="24"
              :sm="24"
              :md="16"
              :lg="16"
              :xl="16"
            >
              <el-form-item :label="$t(item.label)" :label-width="item.labelWidth">
                <el-date-picker
                  style="width: 100%;"
                  v-model="data[item.value]"
                  type="monthrange"
                  value-format="yyyy-MM"
                  align="right"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始月份"
                  end-placeholder="结束月份"
                  :clearable="item.clearable === false ? item.clearable : true"
                  :picker-options="item.pickerOptions"
                />
              </el-form-item>
            </el-col>
            <!-- 二选一单选框 -->
            <el-col
              v-if="item.type == 'radio'"
              :key="index"
              :xs="24"
              :sm="12"
              :md="8"
              :lg="8"
              :xl="8"
            >
              <el-form-item :label="$t(item.label)">
                <el-radio
                  v-model="data[item.value]"
                  :label="item.yes || 'Y'"
                  :placeholder="$t(item.yesLabel) || getPlaceholder(item)"
                >{{item.yesLabel || $t('table.yes')}}</el-radio>
                <el-radio
                  v-model="data[item.value]"
                  :label="item.no || 'N'"
                  :placeholder="$t(item.noLabel) || getPlaceholder(item)"
                >{{$t(item.noLabel) || $t('table.no')}}</el-radio>
              </el-form-item>
            </el-col>
          </template>
        </el-row>
        <div class="text-center">
          <el-button
            v-for="(item, index) in (handle && handle.formBtList) || []"
            v-if="item.show != null ? item.show : true"
            :key="index"
            :class="`filter-${item.type}`"
            v-waves
            :type="item.btType"
            :icon="item.icon"
            :disabled="item.disabled"
            @click="handleClick(item.event)"
            size="mini"
          >{{ $t(item.label) }}</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: "Main",
  props: {
    // 自定义类名
    className: {
      type: String,
    },
    // 表单数据
    data: {
      type: Object,
    },
    tableKey: 0,
    // 相关字段
    fieldList: {
      type: Array,
    },
    // 操作栏配置
    handle: {
      type: Object,
    },
    // 验证规则
    rules: {
      type: Object,
    },
    // 相关的列表
    listTypeInfo: {
      type: Object,
    },
    // label宽度
    labelWidth: {
      type: String,
      default: "120px",
    },
    refObj: {
      type: Object,
    },
  },
  data() {
    return {
      searchForm: false,
      checkeBoxColmuns: [], //被隐藏的列
    };
  },
  watch: {
    data: {
      handler: function (val) {
        // 将form实例返回到父级
        this.$emit("update:refObj", this.$refs.pageform);
      },
      deep: true, // 深度监听
    },
    searchForm() {
      //增加异步触发,searchForm与组件加载完成不同步
      setTimeout(() => {
        this.$emit("update:refObj", this.$refs.pageform);
      }, 0);
    },
  },
  mounted() {
    // 将form实例返回到父级
    this.$emit("update:refObj", this.$refs.pageform);
    this.$nextTick(() => {
     // this.getColmunList();
    });
  },
  methods: {
    _toggle() {
      this.searchForm = !this.searchForm; // 取反
    },
    _getPageId() {
      let name = this.$route.path.replace("/", "").replace(/_/g, "/");

      let data = JSON.parse(window.sessionStorage.getItem("menus_new") || "{}");
      let id = null;
      let pageList = data.forEach((item) => {
        if (item.menuNameNick == name) {
          id = item.id;
        } else {
          item.childMenus.forEach((child) => {
            if (child.menuNameNick == name) {
              id = child.id;
            } else {
              child.childMenus.forEach((menus) => {
                if (menus.menuNameNick == name) {
                  id = menus.id;
                }
              });
            }
          });
        }
      });
      return id;
    },
    getColmunList() {
      let filterFieldList = this.handle.filterFieldList;
      this.$store
        .dispatch("topForm/listHiddenColumn", { menuId: this._getPageId() })
        .then(() => {
          this.checkeBoxColmuns =
            this.$store.state["topForm"].hiddenColumnObj || [];

          this.handle.filterFieldList = filterFieldList.map((field) => {
            let isHear = this.checkeBoxColmuns.every(
              (colmun) => field.prop != colmun.column
            );

            if (!isHear) this.$emit("handleEvent", field.event, field.prop);

            return {
              ...field,
              value: isHear,
            };
          });
        });
    },
    // 获取字段列表
    getConfigList() {
      if (this.fieldList) {
        return this.fieldList.filter(
          (item) =>
            !item.hasOwnProperty("show") ||
            (item.hasOwnProperty("show") && item.show)
        );
      }
    },
    // 得到placeholder的显示table.inputthis.$t('button.ok')
    getPlaceholder(row) {
      if (row.placeholder) {
        return row.placeholder;
      }
      let placeholder;
      if (row.type === "input" || row.type === "textarea") {
        placeholder = this.$t("table.input") + this.$t(row.label);
      } else if (
        row.type === "select" ||
        row.type === "time" ||
        row.type === "date"
      ) {
        placeholder = this.$t("table.select") + this.$t(row.label);
      } else {
        placeholder = this.$t(row.label);
      }
      return placeholder;
    },
    // 绑定的相关事件
    handleEvent(evnet, data) {
      this.$emit("handleEvent", evnet, data);
    },
    // 派发按钮点击事件
    handleClick(event, data) {
      this.$emit("handleClick", event, data);
    },
    remoteMethod(query) {
      this.$emit("remoteMethod", query);
    },
    checkboxOnChange(checked, item) {
      let column = item.prop;
      let columnList = this.handle.filterFieldList
        .filter((item) => !item.value)
        .map((item) => item.prop);

      let data = {
        menuId: this._getPageId(),
        columnList,
      };
      this.$store.dispatch("topForm/userColumnAdd", data).then(() => {
        if (checked)
          this.checkeBoxColmuns = this.checkeBoxColmuns.map((item) =>
            item.column == column ? { ...item, value: true } : item
          );
      });
      this.$emit("handleEvent", item.event, item.prop);
    },
  },
};
</script>






// WEBPACK FOOTER //
// src/components/top-form.vue